import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ProductService } from "../../../services/product-service";
import { ProductReviewService } from "../../../services/product-review-service";

export const Productrevieweditcontent = (props) => {

  const { reviewID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const [ products, setProducts ] = useState([]);

  const productSearch = async () => {
    try{
      const result = await ProductService.allproductsNames([]);

      setProducts(result);
    }catch(err){
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  }

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await ProductReviewService.productReviewStatusUpdate(
        reviewID,
        values
      );

      setSubmitLoading(true);
      notify("Product review successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    ProductReviewSearchID();
      productSearch();
  }, []);

  const [reviewInfo, setReviewInfo] = useState({
    product_id: "",
    user: "",
    review: "",
    rating: "",
    status: "",
    order_id: "",
  });

  const ProductReviewSearchID = async () => {
    try {
      const result = await ProductReviewService.productReviewDetailsID(reviewID);
      const info = {};

      const productReviewdata = result;

      info.product_id = productReviewdata.product_id;
      info.user = productReviewdata.user;
      info.review = productReviewdata.review;
      info.rating = productReviewdata.rating;
      info.status = productReviewdata.status;
      info.order_id = productReviewdata.order_id;

      setReviewInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Product Review</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  product_id: reviewInfo.product_id,
                  user: reviewInfo.user,
                  review: reviewInfo.review,
                  rating: reviewInfo.rating,
                  status: reviewInfo.status,
                  order_id: reviewInfo.order_id,
                }}
                validationSchema={Yup.object().shape({
                  product_id: Yup.string().required("Required"),
                  rating: Yup.string().required("Required"),
                  order_id: Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Product</label>
                        <div className="input-group">
                          <select
                            name="product_id"
                            className="form-control"
                            id="productId"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.product_id}
                            disabled={true}
                          >
                          {products.map((product) => {
                            return (
                              <option key={product.id} value={product.id}>{product.name}</option>
                              )
                            })}
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.product_id && errors.product_id}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">User</label>
                        <div className="input-group">
                          <input
                            name="user"
                            type="text"
                            className="form-control"
                            id="userid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.user}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.user && errors.user}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Review</label>
                        <div className="input-group">
                          <textarea
                            name="review"
                            type="text"
                            className="form-control"
                            id="reviewId"
                            placeholder="Review"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.review}
                            rows={3}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.review && errors.review}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Rating</label>
                        <div className="input-group">
                          <input
                            name="rating"
                            type="number"
                            className="form-control"
                            id="ratingId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.rating}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.rating && errors.rating}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Order Id</label>
                        <div className="input-group">
                          <input
                            name="order_id"
                            type="text"
                            className="form-control"
                            id="orderId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.order_id}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.order_id && errors.order_id}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Status</label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="statusId"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.status}
                          >
                            <option value="PENDING">PENDING</option>
                            <option value="APPROVED">APPROVED</option>
                            <option value="REJECTED">REJECTED</option> 
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.rating && errors.rating}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )} 
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productrevieweditcontent;
